import React, { useEffect } from 'react'
import { bool, func, node, number, shape, string } from 'prop-types'
import {
  Scrim,
  ModalBox,
  ModalHead,
  ModalHeadInfo,
  Eyebrow,
  ModalTitle,
  ModalSub,
  Steps,
  StepDot,
  CloseButton,
  ModalBody,
  ModalFoot
} from './styles'

export default function Modal( { eyebrow, title, sub, steps, wide, onClose, children, footer, canClose } ) {
  useEffect( () => {
    function handleKey( event ) {
      if ( event.key === 'Escape' && canClose ) {
        onClose()
      }
    }
    window.addEventListener( 'keydown', handleKey )
    return () => window.removeEventListener( 'keydown', handleKey )
  }, [ onClose, canClose ] )

  function handleScrimClick( event ) {
    if ( event.target === event.currentTarget && canClose ) {
      onClose()
    }
  }

  const semCabecalho = !eyebrow && !title && !sub && !steps

  return (
    <Scrim onMouseDown={ handleScrimClick }>
      <ModalBox
        $wide={ wide }
        aria-modal="true"
        role="dialog"
      >
        <ModalHead $bare={ semCabecalho }>
          <ModalHeadInfo>
            { eyebrow ? <Eyebrow>{ eyebrow }</Eyebrow> : null }
            { title ? <ModalTitle className="serif">{ title }</ModalTitle> : null }
            { sub ? <ModalSub>{ sub }</ModalSub> : null }
            { steps ? (
              <Steps>
                { [ 0, 1, 2 ].map( ( idx ) => (
                  <StepDot
                    $on={ idx <= steps.cur }
                    key={ idx }
                  />
                ) ) }
              </Steps>
            ) : null }
          </ModalHeadInfo>
          { canClose ? (
            <CloseButton
              aria-label="Fechar"
              onClick={ onClose }
              type="button"
            >×
            </CloseButton>
          ) : null }
        </ModalHead>
        <ModalBody>{ children }</ModalBody>
        { footer ? <ModalFoot>{ footer }</ModalFoot> : null }
      </ModalBox>
    </Scrim>
  )
}

Modal.propTypes = {
  'eyebrow': string,
  'title': string,
  'sub': node,
  'steps': shape( { 'cur': number } ),
  'wide': bool,
  'onClose': func.isRequired,
  'children': node,
  'footer': node,
  'canClose': bool
}

Modal.defaultProps = {
  'eyebrow': null,
  'title': null,
  'sub': null,
  'steps': null,
  'wide': false,
  'children': null,
  'footer': null,
  'canClose': true
}
